const NAMESPACE = "projectform";

const KEYS = {
    projectNumberLabel: "projectNumberLabel",
    unableToSubmitHeading: "unableToSubmitHeading",
    unableToSubmitSubHeading: "unableToSubmitSubHeading",
    missingFieldsHeading: "missingFieldsHeading",
    invalidFormInputsHeading: "invalidFormInputsHeading",
    automationFailuresHeading: "automationFailuresHeading",
    backButtonLabel: "backButtonLabel",
    proceedToPaymentLabel: "proceedToPaymentLabel",
    nextButtonLabel: "nextButtonLabel",
    saveFormDataLabel: "saveFormDataLabel",
    submitButtonLabel: "submitButtonLabel",
    ePaymentSubmitDisabledHelp: "ePaymentSubmitDisabledHelp",
    closePreviewButtonLabel: "closePreviewButtonLabel",
    ePaymentTitle: "ePaymentTitle",
    processingSubmitMessage: "processingSubmitMessage",
    pageLabel: "pageLabel",
    printHeaderText: "printHeaderText",
    emptyPageText: "emptyPageText",
    savedText: "SavedText",
    autoPromotionMessage: "autoPromotionMessage",
    autoPromotionLoadMessage: "autoPromotionLoadMessage"
};

const MESSAGES = {
    [KEYS.projectNumberLabel]: {
        value: "Project Number: {projectNumber}",
        comment: "Label for project number"
    },
    [KEYS.unableToSubmitHeading]: {
        value: "Unable to Submit Form",
        comment: "Header for submission error"
    },
    [KEYS.unableToSubmitSubHeading]: {
        value: "Please fix the errors below and try again.",
        comment: "SubHeading for submission error"
    },
    [KEYS.missingFieldsHeading]: {
        value: "Missing Required Fields:",
        comment: "Header for errors related to missing required fields"
    },
    [KEYS.invalidFormInputsHeading]: {
        value: "Invalid Form Inputs:",
        comment: "Header for errors related to invalid field inputs"
    },
    [KEYS.automationFailuresHeading]: {
        value: "Validation Failures:",
        comment: "Header for errors related to automation failures"
    },
    [KEYS.backButtonLabel]: {
        value: "Back",
        comment: "Label for button which directs to the previous page"
    },
    [KEYS.proceedToPaymentLabel]: {
        value: "Proceed to Payment",
        comment: "Label for button which directs to ePayment page"
    },
    [KEYS.nextButtonLabel]: {
        value: "Next",
        comment: "Label for button which directs to the next page"
    },
    [KEYS.saveFormDataLabel]: {
        value: "Save Form Data",
        comment: "Label for saving data as admin"
    },
    [KEYS.submitButtonLabel]: {
        value: "Submit",
        comment: "Default submit form button label"
    },
    [KEYS.ePaymentSubmitDisabledHelp]: {
        value: "This form cannot be submitted from this page because it requires an ePayment. To proceed, please access this form from the View/Edit page.",
        comment: "Help text to display when the submit button is disabled due to ePayment"
    },
    [KEYS.closePreviewButtonLabel]: {
        value: "Close Preview",
        comment:
            "Label for submit form button label when form is viewed as a preview " +
            "and clicking the button will close the preview."
    },
    [KEYS.ePaymentTitle]: {
        value: "ePayment",
        comment: "Title for ePayment page"
    },
    [KEYS.processingSubmitMessage]: {
        value: "Processing Submit...",
        comment: "Message to display when submission is in progress"
    },
    [KEYS.pageLabel]: {
        value: "Page",
        comment: "Label for buttons on error to navigate to the correct page"
    },
    [KEYS.printHeaderText]: {
        value: "Printout of {title} by {user} at {time} on {date}",
        comment: "Header value for printing displaying who printed the form, which form was printed, and when"
    },
    [KEYS.emptyPageText]: {
        value: "This page intentionally left blank.",
        comment:
            "Text shown when a page in a form is empty, either due to not having any elements, or they are all hidden due to conditional visibility"
    },
    [KEYS.savedText]: {
        value: "Saved",
        comment: "Text shown when project is successfully saved"
    },
    [KEYS.autoPromotionMessage]: {
        value:
            "The {formVersionDescription} form is set to automatically update if a program " +
            "administrator modifies any fields on this form. If this occurs, the information you previously provided may be impacted.",
        comment: "Text shown to applicants to make them aware of automatically promoted forms"
    },
    [KEYS.autoPromotionLoadMessage]: {
        value: "Updating form to the latest version, previous responses may be impacted.",
        comment: "Text displayed when loading form with auto promotion enabled"
    }
};

export { NAMESPACE, KEYS, MESSAGES };
